import { forterService } from '@/services/forterService';

/**
 * Get the Forter token from the Forter service
 * Falls back to reading from cookies if service is not initialized
 */
export const getForterToken = (): string => {
  const serviceToken = forterService.getToken();

  if (serviceToken) {
    return serviceToken;
  }

  // Fallback: try to read from cookies
  return getForterTokenFromCookie();
};

/**
 * Legacy function to read Forter token from cookies
 * Used as fallback if service is not available
 */
const getForterTokenFromCookie = (): string => {
  if (typeof document === 'undefined') {
    return '';
  }

  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'forterToken' || name === '_ftr') {
      return decodeURIComponent(value);
    }
  }
  return '';
};
